
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 800 558","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticClass:"app-inline-svg",attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 0h253v36H0zM0 87h800v272H0zM0 374h555v28H0zM0 426h435v28H0zM0 478h492v28H0zM0 530h385v28H0zM0 51h91v13H0zM637 51h91v13h-91zM743 51h57v13h-57z"}})])])
          )
        }
      }
    